module.exports = __webpack_public_path__ + "img/safari.6b54b0c5.png";